import mutations from "./contractor_history/mutations.js";
import mutation_types from "./mutation_types.js";

export default {
    //general
    [mutation_types.SET_USER_INFO](state, data) {
        Object.assign(state.userInfo, data);
    },
    [mutation_types.ADD_TRANSLATIONS](state, words) {
        state.stored_translations = Object.assign(
            {},
            state.stored_translations,
            words
        );
    },
    [mutation_types.SET_LANG](state, lang) {
        state.lang = lang;
    },
    [mutation_types.ADD_SELECT2_CONTRACTORS](state, contractors) {
        state.select2ContractorsList = [];

        contractors.forEach(contractor => {
            state.select2ContractorsList.push({
                text: contractor.name,
                id: contractor.id,
                is_global: contractor.global_account == 1
            });
        });
    },
    [mutation_types.ADD_SELECT2_ID_NUMBERS](state, contractors) {
        contractors.forEach(contractor => {
            if (
                ![null, undefined, ""].includes(
                    contractor.identification_number
                )
            ) {
                state.select2IdNumbersList.push({
                    text: contractor.identification_number,
                    id: contractor.id,
                    is_global: contractor.global_account == 1
                });
            }
        });
    },
    [mutation_types.SET_SEVER_INO](state, data) {
        state.server_info = data;
    },
    [mutation_types.ADD_SELECT2_DOCUMENTS_CURRENCIES](state, currencies) {
        Object.values(currencies).forEach(currency => {
            state.select2DocumentsCurrenciesList.push({
                text: currency.iso_code,
                id: currency.id
            });
        });
    },
    [mutation_types.SET_COUNTRIES_TRANSLATIONS](state, translations) {
        state.countries_translations = Object.assign(
            {},
            state.countries_translations,
            translations
        );
    }
};
